import { useTranslation } from '@eti/providers';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet/';
import ContactUsContainer from '../containers/ContactUsContainer';
import { ChatProvider } from '../../../common/chat/ChatContext';

const ContactUsPage = ({ pageTitle }) => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet title={t(pageTitle)} />
      <ChatProvider supportedChatTypes={['genesys', 'oriana']}>
        <ContactUsContainer />
      </ChatProvider>
    </>
  );
};

ContactUsPage.propTypes = {
  pageTitle: PropTypes.string,
};

export default ContactUsPage;
